const RECAPTCHA_SITE_KEY_STAGING = '6LeS7XsoAAAAADLAFaL9fKapjcDWjPVeUriP-MFD';
const RECAPTCHA_SITE_KEY_PRODUCTION = '6LfWw3soAAAAAHFXwfg7pycuARSxmIG28sHVTzd8';
const IS_STAGING = process.env.REACT_APP__IS_STAGING === 'true';

export default {
  SLING_APP_URL: process.env.REACT_APP__SLING_APP_URL,
  API_END_POINT: process.env.REACT_APP__API_END_POINT,
  KIOSK_APP_URL: process.env.REACT_APP__KIOSK_APP_URL,
  IS_STAGING,
  SHOULD_SHOW_SIGN_OUT_BUTTON: false,
  RECAPTCHA_SITE_KEY: IS_STAGING ? RECAPTCHA_SITE_KEY_STAGING : RECAPTCHA_SITE_KEY_PRODUCTION,
  FEATURE_FLAGS: {
    ADP_SIGN_IN: false,
    SHIFT_ACCEPTANCE: false,
    AUTOMATED_BREAKS_FOR_KIOSK: true
  }
};
